var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#48C3CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6894 8H6.31064C5.59574 8 5 8.59574 5 9.31064V15.6553C5 16.3702 5.59574 16.966 6.31064 16.966H17.6894C18.4043 16.966 19 16.3702 19 15.6553V9.34043C19 8.59574 18.4043 8 17.6894 8ZM7.83165 15.6553C7.83165 14.7915 7.14654 14.1362 6.3125 14.1362V10.8596C7.17633 10.8596 7.83165 10.1745 7.83165 9.34042H16.1721C16.1721 10.2042 16.8572 10.8596 17.6912 10.8596V14.1362C16.8274 14.1362 16.1721 14.8213 16.1721 15.6553H7.83165ZM14.1729 12.3787C14.1729 13.5797 13.1994 14.5532 11.9985 14.5532C10.7976 14.5532 9.82401 13.5797 9.82401 12.3787C9.82401 11.1778 10.7976 10.2043 11.9985 10.2043C13.1994 10.2043 14.1729 11.1778 14.1729 12.3787Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.5ff2fd723ddf57c06b478b16f72b7c3c.svg";
export { ForwardRef as ReactComponent };